import Localized from 'react-localization';

import en from './en';
import ko from './ko';
import ja from './ja';
import zh from './zh';
import de from './de';
import es from './es';
import fr from './fr';
import hi from './hi';
import it from './it';
import pt from './pt';
import ru from './ru';

const strings = new Localized({
  en, ko, ja, zh, de, es, fr, hi, it, pt, ru
});

export default strings;
